<div class="container-fluid">
  <div class="header">
    <h2>Consultar Microserviços</h2>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label for="filtroItem">Filtrar por Item:</label>
          <input 
            type="text" 
            id="filtroItem" 
            class="form-control" 
            [(ngModel)]="filtroItem"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por item">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="filtroNome">Filtrar por Nome:</label>
          <input 
            type="text" 
            id="filtroNome" 
            class="form-control" 
            [(ngModel)]="filtroNome"
            (keyup)="aplicarFiltros()"
            placeholder="Filtrar por nome">
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label for="filtroStatus">Filtrar por Status:</label>
          <select 
            id="filtroStatus" 
            class="form-control" 
            [(ngModel)]="filtroStatus"
            (change)="aplicarFiltros()">
            <option value="">Todos</option>
            <option value="Ativo">Ativo</option>
            <option value="Inativo">Inativo</option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-md-12">
        <button class="btn btn-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar Filtros
        </button>
      </div>
    </div>
  </div>

  <!-- Tabela -->
  <div class="table-responsive">
    <table class="table">
      <thead>
        <tr>
          <th>Item</th>
          <th>Nome</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let microservico of microservicosPaginados">
          <td>{{ microservico.item }}</td>
          <td>{{ microservico.nome }}</td>
          <td>
            <span [class]="getStatusClass(microservico.status)" 
                  (click)="alterarStatus(microservico)"
                  style="cursor: pointer;"
                  title="Clique para alterar o status">
              {{ microservico.status }}
            </span>
          </td>
          <td>
            <button class="btn btn-sm btn-warning me-2" (click)="editarMicroservico(microservico)" title="Editar">
              <i class="fa fa-edit"></i>
            </button>
            <button class="btn btn-sm btn-danger" (click)="excluirMicroservico(microservico)" title="Excluir">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex justify-content-between align-items-center mt-3" *ngIf="microservicosFiltrados.length > 0">
    <div class="d-flex align-items-center">
      <span class="me-2">Itens por página:</span>
      <select class="form-control form-control-sm" style="width: 90px;" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
        <option [ngValue]="5">5</option>
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
      </select>
    </div>

    <div class="text-muted">
      Página {{ paginaAtual }} de {{ totalPaginas || 1 }}
    </div>

    <div class="d-flex">
      <button class="btn btn-outline-secondary btn-sm me-2" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">Anterior</button>
      <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()" [disabled]="paginaAtual >= totalPaginas">Próxima</button>
    </div>
  </div>

  <!-- Mensagem quando não há dados -->
  <div class="no-data" *ngIf="microservicosFiltrados.length === 0">
    <div class="text-center">
      <i class="fa fa-search fa-3x text-muted mb-3"></i>
      <h4 class="text-muted">Nenhum microserviço encontrado</h4>
      <p class="text-muted">Tente ajustar os filtros ou adicionar novos microserviços.</p>
    </div>
  </div>
</div> 